import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#f4f6fa] py-16 px-5 text-center" data-id="element-70">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-[600px] mx-auto bg-white rounded-2xl p-10 shadow-[0_4px_24px_rgba(0,0,0,0.07)] border-2 border-[#e8ecf4]" data-id="element-71">
        <ShieldCheckIcon className="w-14 h-14 text-gold mx-auto mb-4" data-id="element-72" />
        <h3 className="font-serif text-[1.4rem] text-navy mb-3" data-id="element-73">
          Garantía Total de 7 Días
        </h3>
        <p className="text-[0.95rem] text-[#555]" data-id="element-74">
          Estamos completamente seguros de que este sistema te va a dar claridad
          y herramientas reales para el primer año con tu bebé. Por eso asumimos
          todo el riesgo nosotros. Tienes 7 días completos para leer los tomos y
          usar las herramientas. Si sientes que no es para ti, nos mandas un
          email y te devolvemos el 100% de tu dinero.{' '}
          <strong data-id="element-75">Sin preguntas. Sin complicaciones.</strong>
        </p>
        <p className="mt-5 text-[0.82rem] text-[#2a7a4f] italic" data-id="element-76">
          Tasa de devoluciones actual: menos del 1%
        </p>
      </motion.div>
    </section>;
}